import './scss/style.scss'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import {Provider} from "react-redux";
import {store} from "./redux/store";
import {AppContextProvider} from "./context/AppContext";
import * as Sentry from "@sentry/react"
import { isProduction } from './Utils'

isProduction() && Sentry.init({
  dsn: "https://fbf464fac44d4f21a98749766c9e1332@o4505124563320832.ingest.sentry.io/4505124582850560",
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

(window as any).__runApp = function (roomId: string, defaultView: any, tournament: any) { //for example
  document.body.classList.add('in-game');
  window.scrollTo({
    top: 0
  });
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppContextProvider>
          <App defaultView={defaultView} roomId={roomId} tournament={tournament} />
        </AppContextProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  )

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
}

if (!(window as any).__data) {
  (window as any).__runApp('polish-pawn-10-blitz', 'main')
}
